<template>
  <div class="max-w-[45rem] p-8 mx-auto w-full h-full relative">
    <div class="bg-[#FBFBFC] h-full py-6 rounded-3xl shadow-b-xl">
      <div class="h-full px-6 overflow-auto">
        <div class="py-4"></div>

        <div class="px-6 flex justify items-center gap-6">
          <div class="w-6 h-6" @click="$router.back()">
            <img
              src="@/assets/images/all/arrow-up-black.svg"
              class="object-contain w-full h-full -rotate-90"
              alt=""
            />
          </div>
          <div class="text-2xl font-bold title-color">Détail du paiement</div>
        </div>
        <div class="py-2"></div>
        <div class="flex items-center gap-6">
          <div class="w-14 h-14 rounded-lg border overflow-hidden">
            <img
              :src="paymentData.image"
              alt=""
              class="w-full h-full object-cover"
            />
          </div>
          <div>
            <div>Produit</div>
            <div class="font-bold max-w-[20rem] title-color">
              {{ paymentData.productName }}
            </div>
          </div>
          <div class="ml-auto">
            {{
              $Commons.timestampToDate(paymentData.date, 'DD MMM YYYY, HH:mm')
            }}
          </div>
        </div>
        <div class="py-3 border-b mb-6"></div>

        <div class="flex justify-between items-center">
          <div class="font-bold text-2xl title-color">
            {{ paymentData.price }} FCFA
          </div>
          <div>
            <button
              class="whitespace-nowrap px-4 py-2 font-medium rounded-lg"
              :style="{
                backgroundColor: statuses[paymentData.status]?.background,
                color: statuses[paymentData.status]?.color,
              }"
            >
              {{ statuses[paymentData.status]?.name }}
            </button>
          </div>
        </div>
        <div class="py-4"></div>
        <div class="border p-4 rounded-xl flex flex-col gap-3 divide-y">
          <div>
            <div>Description</div>
            <div class="font-bold  ">
              {{ paymentData.description||'-' }}
            </div>
          </div>
          <div>
            <div>Client</div>
            <div class="font-bold  ">
              {{ paymentData.customerName||'-' }}
            </div>
          </div>
          <div>
            <div>Réference</div>
            <div class="font-bold  ">
              {{ paymentData.id||'-' }}
            </div>
          </div>
          <div>
            <div>Detail de paiement</div>
            <div class="font-bold  ">
                {{   $t('transactions.detailedStatus.'+paymentData.statusMessage) }}
            </div>
          </div>
        </div>

        <!-- {{ paymentData }} -->
        <div class="py-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OrderDetails',
  components: {},
  props: {
    paymentData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      statuses: {
        pending: {
          id: 'pending',
          name: 'En attente',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        success: {
          id: 'success',
          name: 'Réussi',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        error: {
          id: 'error',
          name: 'Echoué',
          background: '#EEF2F3',
          color: '#696969',
        },
      },
    }
  },
  mounted() {},
  unmounted() {},
  methods: {},
  computed: {},
  watch: {},
})
</script>
